'use client'

// src/api/minify.ts
var minifyGqlQuery = (query) => {
  return query.replace(/#.*\n/g, "").replace(/\s+/g, " ").replace(/\s*([{}():=@$.,])\s*/g, "$1").trim();
};

export {
  minifyGqlQuery
};
//# sourceMappingURL=chunk-UBYW5IHO.mjs.map